function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("title", null, "ICONS/ico-30-colorSwatch");

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "ICONS/ico-30-colorSwatch"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15,6 L20.3425357,16.1508178 C21.8954836,19.1014188 20.7624619,22.7522664 17.8118609,24.3052143 C16.9448368,24.7615428 15.9797788,25 15,25 C11.6656795,25 8.96267866,22.2969992 8.96267866,18.9626787 C8.96267866,17.9828999 9.20113586,17.0178419 9.65746433,16.1508178 L15,6 L15,6 Z",
  id: "doublure",
  fill: "#FFFFFF",
  opacity: 0.4
}), /*#__PURE__*/React.createElement("path", {
  d: "M15,6 L19.9750776,15.9501553 C21.3489074,18.6978148 20.2351983,22.038942 17.4875388,23.4127717 C16.7151824,23.7989499 15.8635207,24 15,24 C11.9280233,24 9.4376941,21.5096708 9.4376941,18.4376941 C9.4376941,17.5741734 9.63874416,16.7225117 10.0249224,15.9501553 L15,6 L15,6 Z",
  id: "goutte",
  fill: "#000000"
})));

const SvgIco30ColorSwatch = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "30px",
  height: "30px",
  viewBox: "0 0 30 30",
  ref: svgRef
}, props), title === undefined ? _ref : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIco30ColorSwatch, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ico-30-colorSwatch.2b9e2035.svg";
export { ForwardRef as ReactComponent };